export default {
  setup: "1.1 الخطوة",
  setupService: "تنصيب خدمة Ordering",
  pickupBranches: "الفروع",
  brandSettings: "اعدادات خاصة بالمتجر",
  menu: "القائمة",
};
